import axios from 'axios';
import { clearAuthSession, getAuthToken } from '../auth/cookieUtils';
import { API_BASE_URL } from '../config/runtimeConfig';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

export const applyAuthToken = (config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const handleResponseError = (
  error,
  redirectToLogin = () => window.location.assign('/login')
) => {
  if (error.response?.status === 401) {
    clearAuthSession();
    if (window.location.pathname !== '/login') {
      redirectToLogin();
    }
  }
  return Promise.reject(error);
};


// Add Authorization header with JWT from cookie for every request
axiosInstance.interceptors.request.use(
  applyAuthToken,
  (error) => Promise.reject(error)
);



// Handle expired/invalid token and redirect to login
axiosInstance.interceptors.response.use(
  (response) => response,
  handleResponseError
);



export default axiosInstance;
